let URL;
let appMode = process.env.REACT_APP_ENV;
let ASSET_URL = "http://103.189.173.7:7023/api";

if (appMode === "development") {
  URL = "http://103.189.173.7:2361/api";
} else {
  //  URL = "https://backend.teamintelligencehub.com/api";
  URL = "https://backend.teamintelligencehub.com/api";
  // URL ="http://localhost:3836/api";
  // URL = "http://45.194.47.66:3022/api";
}

// 153.92.4.13:6555

let apiPath = {
  baseURL: URL,
  assetURL: ASSET_URL,
  dashboard: "admin/auth/dashboard",

  // Auth API
  logout: "admin/auth/logout",
  login: "admin/auth/login",
  teamManager: "admin/team-manager",
  adminManager: "admin/user",
  adminUserManager: "admin/users",
  profile: "admin/auth/get-profile",
  updateProfile: "admin/auth/update-profile",
  changePassword: "admin/auth/change-password",
  updateAppSetting: "admin/auth/update-app-setting",

  forgotPassword: "admin/auth/forgot-password",
  verifyOTP: "admin/auth/verify-otp",
  resetPassword: "admin/auth/reset-password",
  // Other APIs
  customerManager: "/admin/master-facilitator",
  CertifiedPractitioner: "/admin/certified-practitioner",
  impersonate: "/admin/auth/generate-token",
  common: {
    userOrVendors: "common/user-or-vendor",
    vendors: "common/vendor",
    designers: "common/designer",
  },
};

export default apiPath;
